import SimpleRichTextComponent from "@/components/SimpleRichText";
import { SimpleRichTextProps } from "@/components/SimpleRichText/SimpleRichText";
import { Container, Article } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const SimpleRichText = SimpleRichTextComponent as any;

const PaddingRichText: React.FC<SimpleRichTextProps> = (props) => {
  return (
    <Container>
      <Article>
        <SimpleRichText {...props} />
      </Article>
    </Container>
  );
};

export default PaddingRichText;
